<template>
  <el-dialog @open="open" title="" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="600px" :show-close="false">
    <template slot="title">
      <i class="el-icon-s-promotion"></i>
      Envio de extratos por e-mail.
    </template>
    <el-row :gutter="24">
      <el-col :span="24">
        <ul style="list-style-type: none; height: 200px; overflow-y: auto;">
          <li style="display: flex; flex-direction: row; justify-content: space-between; font-size: 16px; margin-bottom: 10px; margin-right: 10px;">
            <span style="width: 100px; text-align: left;"><i class="el-icon-s-management"></i> Id contrato</span>
            <span style="width: 200px; text-align: left;"><i class="el-icon-message"></i> Email proprietario</span>
            <span>Status</span>
          </li>
          <li v-for="item in extratosParaEnviar" :key="item.id" style="display: flex; flex-direction: row; justify-content: space-between; font-size: 13px; margin-bottom: 5px; margin-right: 10px;">
            <span style="width: 100px; text-align: left;">{{ item.idNaImobiliaria ? item.idNaImobiliaria : item.imovel.idNaImobiliaria }}</span>
            <span style="width: 200px; text-align: left;" class="dont-wrap">{{ item.imovel.proprietariosBeneficiarios[0].email }}</span>
            <span style="width: 39px; text-align: center; font-size: 18px;">
              <i v-if="!enviado" class="el-icon-loading" style="color: #4B6EF6;"></i>
              <i v-else :class="item.isEmailEnviado ? 'el-icon-circle-check' : 'el-icon-circle-close'" :style="{ color: item.isEmailEnviado ? '#2DB748' : '#DF1B1B' }"></i>
            </span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <span slot="footer">
      <el-button v-if="enviado" @click="fechar" type="primary" size="small" round class="btn-box-shadow">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    visibility: Boolean,
    envios: Array,
    payload: Object
  },
  
  data() {
    return {
      enviado: false,
      extratosEnviados: []
    }
  },

  computed: {
    extratosParaEnviar() {
      return this.enviado ? this.extratosEnviados : this.envios 
    }
  },

  methods: {
    ...mapActions('dimobStore', {
      enviarExtratosEmail: 'enviarExtratosEmail'
    }),

    open() {
      this.enviarEmails();
    },

    enviarEmails() {
      this.enviarExtratosEmail(this.payload)
      .then(resultado => {
        switch (resultado.status) {
          case 'SUCESSO':
            this.preencherResultado(resultado.lista);
            this.enviado = true;
            break;
          case 'FALHA':
            this.$message.warning(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error('Ocorreu um erro ao se comunicar com o servidor, tente novamente.')
      });
    },

    preencherResultado(listaResultado) {
      let listaAtualizada = [];

      for(let x = 0; x < this.envios.length; x++) {
        for(let i = 0; i < listaResultado.length; i++) {
          switch (listaResultado[i].tipoContrato) {
            case "ALUGUEL":
              if(listaResultado[i].aluguel.id === this.envios[x].id && listaResultado[i].aluguel.imovel.proprietariosBeneficiarios[0].id === this.envios[x].imovel.proprietariosBeneficiarios[0].id) {
                listaAtualizada.push({ ...this.envios[x], isEmailEnviado: listaResultado[i].isEmailEnviado })
                break;
              }   
              break;
            case "VENDA":
              if(listaResultado[i].venda.id === this.envios[x].id && listaResultado[i].venda.imovel.proprietariosBeneficiarios[0].id === this.envios[x].imovel.proprietariosBeneficiarios[0].id) {
                listaAtualizada.push({ ...this.envios[x], isEmailEnviado: listaResultado[i].isEmailEnviado })
                break;
              }   
              break;
          }
        }
      }

      this.extratosEnviados = listaAtualizada;
    }, 

    fechar() {
      this.$emit('close');
      this.reset();
    },

    reset() {
      this.enviado = false
      this.extratosEnviados = []
    }
  }
}
</script>